import { render } from "./SetupPlacement.vue?vue&type=template&id=206c1a82"
import script from "./SetupPlacement.vue?vue&type=script&lang=js"
export * from "./SetupPlacement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__